import React from 'react';
import {
  Box,
  Typography,
  Paper,
  List,
  ListItem,
  Divider,
  Alert,
  Chip
} from '@mui/material';

import { Icon } from '@iconify/react';
import SessionCard from './SessionCard';
import { Status, statusColorMap } from '../constants/ocpi.constant';
import { useTheme } from '@mui/material';
import { Loader } from 'src/components/Loader';
import { useSendCommand } from 'src/hooks/useOcpiCommands.hook';

const SessionList = ({ 
  title, 
  sessions, 
  isOngoing = false, 
  emptyMessage = "No sessions found",
  icon = "eva:list-fill",
  loading = false,
  showCdrDetails = false,
  refetch = () => {},
  changeActiveTab = () => {}
}) => {
  const theme = useTheme();
  const sendCommandMutation = useSendCommand("sendCommand");

  const handleStopSession = async (session) => {
    await sendCommandMutation.mutateAsync(session);
    setTimeout(() => {
      refetch();
      changeActiveTab(1);
    }, 400);
  };

  if (loading) {
    return <Loader variant="skeleton" skeletonCount={1} skeletonVariant="sessionCard" />;
  }

  if (!sessions || sessions.length === 0) {
    return (
      <Paper sx={{ p: 3, mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <Icon 
            icon={icon} 
            fontSize={24}
            color={theme.palette.info.main}
          />
          <Typography variant="h6" component="h2" marginLeft={1}>
            {title}
          </Typography>
          <Chip 
            label={sessions?.length || 0} 
            size="small" 
            color={statusColorMap[isOngoing ? Status.SESSION_ACTIVE : Status.SESSION_COMPLETED].color}
            sx={{ ml: 2 }}
          />
        </Box>
        
        <Alert severity="info" sx={{ mt: 2 }}>
          {emptyMessage}
        </Alert>
      </Paper>
    );
  }

  return (
    <Paper sx={{ p: 3, mb: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
        <Icon 
          icon={icon} 
          color={isOngoing ? theme.palette.primary.main : theme.palette.info.main}
          fontSize={24}
          className={ isOngoing ? 'pulse' : '' }
        />
        <Typography variant="h6" component="h2" sx={{ flexGrow: 1, marginLeft: 1 }}>
          {title}
        </Typography>
        <Chip
          label={sessions.length}
          color={statusColorMap[Status.SESSION_ACTIVE].color}
          size="small"
        />
      </Box>
      
      <List sx={{ p: 0 }}>
        {sessions.map((session, index) => (
          <React.Fragment key={session.sessionId}>
            <ListItem sx={{ p: 0, display: 'block' }}>
              <SessionCard 
                session={session} 
                isOngoing={isOngoing}
                onStopSession={handleStopSession}
                showCdrDetails={showCdrDetails}
              />
            </ListItem>
            {index < sessions.length - 1 && (
              <Divider sx={{ my: 2 }} />
            )}
          </React.Fragment>
        ))}
      </List>
    </Paper>
  );
};

export default SessionList;
